module.exports = "/src/views/player/hudevo/ipad/components/fractions/elements/tasks/images/6.png";